const $ = require( "jquery" )
window.Handlebars = require( "handlebars/dist/handlebars.min.js" )
window.slicknav = require( "../../node_modules/slicknav/jquery.slicknav" )
window.syncInput = require( "./library/syncInput" )

Handlebars.registerHelper( 'stripScripts', function ( param ) {
  var regex = /(<([^>]+)>)/ig
  return param.replace( regex, "" ).replace( /[^a-zA-Z0-9\s]/g, '' )
} )

$( '#primary-menu > li ' ).on( 'click', function ( e ) {
  $( '.mega-menu-container', $( this ) ).addClass( 'active' )
} )

require( "./modules/nav" )
require( "./modules/slider" )
require( "./modules/Subscriptions" )
require( "./modules/AcademySubscription" )
require( "./modules/PlanComparison" )
require( "./modules/Enterprise" )
require( "./modules/gse" )
require( "./modules/ContactForm" )
require( "./modules/Resellers" )
require( "./modules/EnterpriseCheckout" )
require( "./modules/Accounts" )
require( "./modules/Checkout" )